module.exports = "ng2-map {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/map-component/map.component.css
// module id = ./src/app/sharedcomponents/map-component/map.component.css
// module chunks = main